const timeFormat = new Intl.DateTimeFormat("en-US", {
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
});

const dateFormat = new Intl.DateTimeFormat("en-US", {
  day: "2-digit",
  month: "2-digit",
  year: "2-digit",
});

// Сервер может прислать секунды или миллисекунды — приводим к Date.
const toDate = (timestamp: number): Date =>
  new Date(timestamp < 1e12 ? timestamp * 1000 : timestamp);

const safeFormat = (format: Intl.DateTimeFormat, timestamp: number): string => {
  const date = toDate(timestamp);
  return Number.isNaN(date.getTime()) ? "---" : format.format(date);
};

// "ЧЧ:ММ:СС" в локальном времени.
export const formatTime = (timestamp: number): string =>
  safeFormat(timeFormat, timestamp);

// "ММ/ДД/ГГ" в локальном времени.
export const formatDate = (timestamp: number): string =>
  safeFormat(dateFormat, timestamp);
